import { render, staticRenderFns } from "./LegoCardPriusMap.vue?vue&type=template&id=d390cf90&scoped=true&"
import script from "./LegoCardPriusMap.vue?vue&type=script&lang=ts&"
export * from "./LegoCardPriusMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d390cf90",
  null
  
)

export default component.exports